import { Checkbox, Flex, Group, Title } from "@mantine/core";

import {
  PostpartumFlowsheetMenuButton,
  PostpartumFlowsheetQuickButton,
} from "@/encounters/components/EncounterLabor/constants/postpartum-flowsheets";
import PostpartumMenuButton from "@/encounters/components/EncounterLabor/EncounterLaborPostpartum/PostpartumMenu/PostpartumFlowsheetMenuButtons";
import { PostpartumFlowsheetQuickButtons } from "@/encounters/components/EncounterLabor/EncounterLaborPostpartum/PostpartumMenu/PostpartumFlowsheetQuickButtons";

interface PostpartumFlowsheetHeaderProps {
  encounterId: string;
  clientId: string;
  title: string;
  quickButtons: readonly PostpartumFlowsheetQuickButton[];
  menuButtons: readonly PostpartumFlowsheetMenuButton[];
  showNumbersOnly: boolean;
  setShowNumbersOnly: (showNumbersOnly: boolean) => void;
  onRefresh?: () => Promise<void>;
  isViewOnly: boolean;
  headerBgColor?: string;
}

export default function PostpartumFlowsheetHeader({
  encounterId,
  clientId,
  title,
  quickButtons,
  menuButtons,
  showNumbersOnly,
  setShowNumbersOnly,
  onRefresh,
  isViewOnly,
  headerBgColor = "white.0",
}: PostpartumFlowsheetHeaderProps) {
  return (
    <Flex mb={16} gap="md" direction="column" bg={headerBgColor}>
      <Flex align="center" justify="space-between">
        <Title order={3}>{title}</Title>
        <Group>
          <Checkbox
            label="Show numbers only"
            checked={showNumbersOnly}
            onChange={(e) => setShowNumbersOnly(e.target.checked)}
          />
          {!isViewOnly && (
            <PostpartumMenuButton
              clientId={clientId}
              onRefresh={onRefresh}
              encounterId={encounterId}
              flowSheetButtons={[...menuButtons]}
            />
          )}
        </Group>
      </Flex>
      {!isViewOnly && (
        <PostpartumFlowsheetQuickButtons
          clientId={clientId}
          onRefresh={onRefresh}
          encounterId={encounterId}
          flowSheetButtons={[...quickButtons]}
        />
      )}
    </Flex>
  );
}
